import ClientDetailContainer from "./ClientDetailContainer";
export default ClientDetailContainer;
